import { render, staticRenderFns } from "./MenuTools.vue?vue&type=template&id=3a81d354&scoped=true"
import script from "./MenuTools.vue?vue&type=script&lang=js"
export * from "./MenuTools.vue?vue&type=script&lang=js"
import style0 from "./MenuTools.vue?vue&type=style&index=0&id=3a81d354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a81d354",
  null
  
)

export default component.exports